<template>
  <footer class="bg-primary py-3 mt-auto">
    <div class="container text-light">
      <div class="text-center">
        <router-link
          :to="{ name: 'profile', params: { feedback: true } }"
          class="btn btn-link d-block d-md-inline"
          v-if="emailVerified"
        >
          {{ $t("feedback") }}
        </router-link>

        <router-link
          class="btn btn-link d-block d-md-inline"
          :to="{ name: 'licenses' }"
        >
          {{ $t("licenses") }}
        </router-link>

        <a
          class="btn btn-link d-block d-md-inline"
          href="https://numbersofsuccess.com/legal"
          target="_blank"
        >
          {{ $t("legalNotice") }}
        </a>

        <a
          class="btn btn-link d-block d-md-inline"
          href="https://numbersofsuccess.com/privacy"
          target="_blank"
        >
          {{ $t("privacy") }}
        </a>

        <a
          class="btn btn-link d-block d-md-inline"
          href="https://numbersofsuccess.com/terms"
          target="_blank"
        >
          {{ $t("terms") }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheFooter",
  computed: {
    ...mapGetters({
      emailVerified: "user/isEmailVerified",
    }),
  },
};
</script>

<style scoped></style>
